var map = {
	"./blog.yml": 95,
	"./cloud.yml": 96,
	"./color.yml": 97,
	"./country.yml": 98,
	"./doc.yml": 99,
	"./emoji.yml": 100,
	"./flag.yml": 101,
	"./git.yml": 102,
	"./icon.yml": 103,
	"./license.yml": 104,
	"./link.yml": 105,
	"./people.yml": 106,
	"./soft.yml": 107,
	"./src.yml": 108,
	"./status.yml": 109,
	"./taxonomy.yml": 110
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94;